import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";

export function FileUpload({ category = "general", accept, onUploaded, testid = "file-upload", label = "Subir", className = "" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) {
      toast.error("El archivo no debe superar 15MB");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("category", category);
      const res = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Archivo subido");
      onUploaded?.(res.data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" accept={accept} className="hidden" data-testid={`${testid}-input`} onChange={onChange} />
      <Button
        type="button" variant="outline" size="sm" disabled={busy}
        data-testid={`${testid}-button`} className={className}
        onClick={() => inputRef.current?.click()}
      >
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />}
        {label}
      </Button>
    </>
  );
}
